







































import Vue from 'vue';
import TitleWidget from "@/components/common/TitleWidget.vue";
import stringsKeys from "@/i18n/strings.json";
import {Device, PortfolioProject} from "@/components/portfolio/PortfolioProject.ts";
import {DeviceViewModel} from "@/components/portfolio/DeviceViewModel";
import DeviceView from "@/components/portfolio/Device.vue";
import carousel from 'vue-owl-carousel'

export default Vue.extend({
  name: 'PortfolioInterface',
  components: {DeviceView, TitleWidget, carousel},
  props: {
    project: {
      type: Object as () => PortfolioProject,
      required: true
    }
  },
  computed: {
    devicesViewModel: function (): DeviceViewModel[] {
      return this.project.getInterfaceImages().map(this.getViewModel)
    },
    sliderOption(): any {
      return {
        0: {
          nav: false,
        },
        576: {
          nav: true,
          navText: ['<img class=rotate-180 src=/img/arrow-black.svg>', '<img  src=/img/arrow-black.svg>'],
        },
        992: {
          nav: true,
          navText: ['<img class=rotate-180 src=/img/arrow-black.svg>', '<img  src=/img/arrow-black.svg>'],
          items: this.countSlideItems,
          margin: 0,
        }
      }
    },
    countSlideItems(): number {
      const desktopIndex: number = this.project.getInterfaceImages().findIndex((item: any) => item.getType() === 'DESKTOP');
      return desktopIndex !== -1 ? 2 : 4;
    }
  },
  data() {
    return {
      carousel: carousel,
      locale: stringsKeys,
      loaded: false,
    }
  },
  methods: {
    getViewModel(device: Device): DeviceViewModel {
      return new DeviceViewModel(device);
    },
  },
});
